class Widget {

    constructor(duration, content) {
        this.duration = duration;
        this.data = content;
    }

    show(){
        var widget = $("<div>").appendTo("#preview-container");
        widget.addClass("widget");
        // widget.contents().find("body");
        widget.css({margin: 0, padding: 0}).html(this.data);
    }

    /**
     * Hide (removes) all widgets
     */
    hide() {
        $(".widget").remove();
    }
}
